var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-row"},_vm._l((_vm.headers),function(header,j){return _c('td',{key:j,staticClass:"table-cell",class:_vm.alignment(header)},[_vm._v("\n    "+_vm._s(_vm.showData(_vm.item, header))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }